import {useReducer} from "react";

function flip(b) {
    return !b;
}

function useToggle(initialValue) {
    return useReducer(flip, initialValue);
}

export default useToggle;
